import 'jquery'
import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'open-iconic/font/css/open-iconic-bootstrap.css'
import 'flatpickr/dist/flatpickr.css'
import Layout from './layout/index.js'
import Vue, { createSSRApp } from 'vue'

import { Portal, PortalTarget } from 'portal-vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import outlet from './outlet/index.js'

Vue.component('Portal', Portal)
Vue.component('PortalTarget', PortalTarget)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(flatPickr)
Vue.component('flat-pickr', flatPickr)
Vue.component('layout', Layout)

export function createApp () {
  return createSSRApp({
    ...outlet,
    errorHandler (err, instance, info) {}
  })
}
